import React, {useEffect} from 'react';
import {
    HashRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import { Layout } from './layout/Layout';
import { Home } from './pages/home/Home';
import { Info } from './pages/info/Info';
import { Gallery11 } from './pages/gallery/11/gallery11';
import { Gallery13a } from './pages/gallery/13a/gallery13a';
import { Gallery13b } from './pages/gallery/13b/gallery13b';
import { Gallery13c } from './pages/gallery/13c/gallery13c';
import { Gallery13d } from './pages/gallery/13d/gallery13d';
import { Gallery14a } from './pages/gallery/14a/gallery14a';
import { Gallery14b } from './pages/gallery/14b/gallery14b';
import { Gallery15a } from './pages/gallery/15a/gallery15a';
import { Gallery15b } from './pages/gallery/15b/gallery15b';
import { Gallery15c } from './pages/gallery/15c/gallery15c';
import { Gallery15d } from './pages/gallery/15d/gallery15d';
import { Gallery15e } from './pages/gallery/15e/gallery15e';
import { Gallery15f } from './pages/gallery/15f/gallery15f';
import { Gallery16a } from './pages/gallery/16a/gallery16a';
import { Gallery16b } from './pages/gallery/16b/gallery16b';
import { Gallery16c } from './pages/gallery/16c/gallery16c';
import { Gallery16d } from './pages/gallery/16d/gallery16d';
import { Gallery16e } from './pages/gallery/16e/gallery16e';
import { Gallery17a } from './pages/gallery/17a/gallery17a';
import { Gallery17b } from './pages/gallery/17b/gallery17b';
import { Gallery17c } from './pages/gallery/17c/gallery17c';
import { Gallery17d } from './pages/gallery/17d/gallery17d';
import { Gallery17e } from './pages/gallery/17e/gallery17e';
import { Gallery18a } from './pages/gallery/18a/gallery18a';
import { Gallery18b } from './pages/gallery/18b/gallery18b';
import { Gallery18c } from './pages/gallery/18c/gallery18c';
import { Gallery19a } from './pages/gallery/19a/gallery19a';
import { Gallery20a } from './pages/gallery/20a/gallery20a';
import { Gallery20b } from './pages/gallery/20b/gallery20b';
import { Gallery20c } from './pages/gallery/20c/gallery20c';
import { Gallery20d } from './pages/gallery/20d/gallery20d';
import { Gallery20e } from './pages/gallery/20e/gallery20e';
import { Gallery21a } from './pages/gallery/21a/gallery21a';
import { Gallery21b } from './pages/gallery/21b/gallery21b';
import { Gallery21c } from './pages/gallery/21c/gallery21c';
import { Gallery21d } from './pages/gallery/21d/gallery21d';

export const App = () => {
    return (
        <Router>
            <Layout>
                <Switch>
                    <Route exact path={["/"]}>
                        <Home />
                    </Route>
                    <Route path="/information">
                        <Info />
                    </Route>
                    <Route path="/gallery/11">
                        <Gallery11 />
                    </Route>
                    <Route path="/gallery/13a">
                        <Gallery13a />
                    </Route>
                    <Route path="/gallery/13b">
                        <Gallery13b />
                    </Route>
                    <Route path="/gallery/13c">
                        <Gallery13c />
                    </Route>
                    <Route path="/gallery/13d">
                        <Gallery13d />
                    </Route>
                    <Route path="/gallery/14a">
                        <Gallery14a />
                    </Route>
                    <Route path="/gallery/14b">
                        <Gallery14b />
                    </Route>
                    <Route path="/gallery/15a">
                        <Gallery15a />
                    </Route>
                    <Route path="/gallery/15b">
                        <Gallery15b />
                    </Route>
                    <Route path="/gallery/15c">
                        <Gallery15c />
                    </Route>
                    <Route path="/gallery/15d">
                        <Gallery15d />
                    </Route>
                    <Route path="/gallery/15e">
                        <Gallery15e />
                    </Route>
                    <Route path="/gallery/15f">
                        <Gallery15f />
                    </Route>
                    <Route path="/gallery/16a">
                        <Gallery16a />
                    </Route>
                    <Route path="/gallery/16b">
                        <Gallery16b />
                    </Route>
                    <Route path="/gallery/16c">
                        <Gallery16c />
                    </Route>
                    <Route path="/gallery/16d">
                        <Gallery16d />
                    </Route>
                    <Route path="/gallery/16e">
                        <Gallery16e />
                    </Route>
                    <Route path="/gallery/17a">
                        <Gallery17a />
                    </Route>
                    <Route path="/gallery/17b">
                        <Gallery17b />
                    </Route>
                    <Route path="/gallery/17c">
                        <Gallery17c />
                    </Route>
                    <Route path="/gallery/17d">
                        <Gallery17d />
                    </Route>
                    <Route path="/gallery/17e">
                        <Gallery17e />
                    </Route>
                    <Route path="/gallery/18a">
                        <Gallery18a />
                    </Route>
                    <Route path="/gallery/18b">
                        <Gallery18b />
                    </Route>
                    <Route path="/gallery/18c">
                        <Gallery18c />
                    </Route>
                    <Route path="/gallery/19a">
                        <Gallery19a />
                    </Route>
                    <Route path="/gallery/20a">
                        <Gallery20a />
                    </Route>
                    <Route path="/gallery/20b">
                        <Gallery20b />
                    </Route>
                    <Route path="/gallery/20c">
                        <Gallery20c />
                    </Route>
                    <Route path="/gallery/20d">
                        <Gallery20d />
                    </Route>
                    <Route path="/gallery/20e">
                        <Gallery20e />
                    </Route>
                    <Route path="/gallery/21a">
                        <Gallery21a />
                    </Route>
                    <Route path="/gallery/21b">
                        <Gallery21b />
                    </Route>
                    <Route path="/gallery/21c">
                        <Gallery21c />
                    </Route>
                    <Route path="/gallery/21d">
                        <Gallery21d />
                    </Route>
                </Switch>
            </Layout>
        </Router>
    );
};

export default App;


// WEBPACK FOOTER //
// ./src/App.js